import type {UserPreference} from 'services/userPreferences/types';
import {type ShortcutCommand, type ShortcutCommandMap} from '../types';

export const createActiveShortcutCommandMap = (
  activeShortcutCommands: ShortcutCommand[],
  defaultShortcutCommands: ShortcutCommandMap,
  userPreferences: UserPreference[] | undefined,
): ShortcutCommandMap => {
  const allShortcuts: Partial<ShortcutCommandMap> = {};
  (activeShortcutCommands ?? []).forEach(command => {
    allShortcuts[command as keyof ShortcutCommandMap] =
      defaultShortcutCommands[command as keyof ShortcutCommandMap] ?? '';
  });

  const userShortcuts: Partial<ShortcutCommandMap> = {};
  (userPreferences ?? []).forEach(item => {
    userShortcuts[item.name as keyof ShortcutCommandMap] =
      item.value ??
      defaultShortcutCommands[item.name as keyof ShortcutCommandMap] ??
      '';
  });

  return {...allShortcuts, ...userShortcuts};
};
